// @ts-check
import mitt, { } from 'mitt'





const eventBus = mitt()

if (process.env.BROWSER) {
  ;(window ).__eventBus = eventBus
}










function on(
  eventName,
  component_,
  method,
) {
  let component
  if (typeof method === 'undefined') {
    method = component_ 
    component = undefined
  } else {
    component = component_ 
  }
  const callback = method.bind(component)
  eventBus.on(eventName, callback)
  if (component) {
    component.on('destroy', () => {
      eventBus.off(eventName, callback)
    })
  }
}

const emit = eventBus.emit
export { eventBus, on, emit }
